// extracted by mini-css-extract-plugin
export var documentation = "_k7-1";
export var menu = "_k7-0";